import React from 'react';
import {Button} from "react-bootstrap";
import Autosuggest from 'react-autosuggest';
import {connect} from "react-redux";
import {push} from 'react-router-redux';
import {CART_ITEM_QRY, CATEGORY_QRY} from "../../common/constants";

class StoreSearch extends React.Component {

    state = {
        value: '',
        suggestions: [],
        show: false
    };

    getSuggestions = value => {
        const inputValue = value.trim().toLowerCase();
        const inputLength = inputValue.length;
        return inputLength === 0 ?
            [] :
            this.props.itemsList
                .filter(item => item.title.toLowerCase().includes(inputValue))
                .slice(0, 10);
    };

    getSuggestionValue = (suggestion) => suggestion.title;

    renderSuggestion = (suggestion, {isHighlighted}) => {
        return (
            <div className={`search-item-row${isHighlighted ? ' highlighted' : ''}`}>
                <img src={suggestion.imageUrl} className="search-item-img"/>
                <span className="search-item-text">{suggestion.title}</span>
            </div>
        );
    }

    onSuggestionSelected = (_, {suggestion}) => {
        this.setState({show: false});
        this.props.openItem(suggestion.key, suggestion.category);
    }

    onChange = (event, { newValue }) => {
        this.setState({
            value: newValue
        });
    };

    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestions: this.getSuggestions(value)
        });
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
            show: false,
            value: ''
        });
    };

    render() {
        const { show, value, suggestions } = this.state;

        const inputProps = {
            placeholder: 'Search Items',
            value,
            onChange: this.onChange,
            className: `search-input`,
            autoFocus: 'autofocus'
        };

        const toggleSearch = () => {
            this.setState({show: !show})
        }

        return (<div className={`header-search ${show ? 'show-input' : 'hide-input'}`}>
            {show &&
            <Autosuggest
                suggestions={suggestions}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                getSuggestionValue={this.getSuggestionValue}
                renderSuggestion={this.renderSuggestion}
                onSuggestionSelected={this.onSuggestionSelected}
                inputProps={inputProps}
                focusInputOnSuggestionClick={false}
            />}
            <Button className="search-btn" onClick={toggleSearch}/>
        </div>);
    }
}

const mapStateToProps = (state) => {
    const itemsList = [];
    for (let key in state.itemsList) {
        if (state.itemsList.hasOwnProperty(key)) {
            const item = state.itemsList[key];
            if (!item.variation && (state.staticData.showUnavailableItemsInStore || item.available > 0)) {
                const {title, imageUrl, category} = item;
                itemsList.push({key, title, imageUrl, category});
            }
        }
    }
    return {
        itemsList,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        openItem: (key, category) => {
            dispatch(push(`${location.pathname}${CART_ITEM_QRY}=${key}${CATEGORY_QRY}=${category}`));
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)( StoreSearch );






// WEBPACK FOOTER //
// ./src/components/store/StoreSearch.js